import React from 'react';
import { Alert } from 'reactstrap';
import CompanyGroups from './CompanyGroups';
import SortIcons from './ProposalsSortIcons';
const CompanyGroupList = ({
  companies = [],
  disabledCompany,
  onDelete,
  onEdit,
  onSetStatus,
  deleteMode,
  onRecover,
  onSort,
  sortValue,
}) => {
  // let merge = [];
  // companies.forEach((i,idx,x)=>{
  //     merge = merge.concat(i.groupSuperAdmins);
  //     merge = merge.concat(i.managedCompanies);
  //     (idx == x.length - 1) ? console.log("Created Merge : ",merge) : console.log(".")
  // })
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            {/* <td>ID</td> */}
            <th className="cursor-pointer" onClick={() => companies.length > 0 && onSort('name')}>
              Group Name <SortIcons sortObj={sortValue} sortName="name" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => companies.length > 0 && onSort('company[name]')}
            >
              Management Company <SortIcons sortObj={sortValue} sortName="company[name]" />
            </th>

            <th>Members</th>
            <th>Managed Devices</th>
            <th>Monitored Devices </th>

            <th
              className="cursor-pointer"
              onClick={() => companies.length > 0 && onSort('managedCompanies')}
            >
              Managed Companies <SortIcons sortObj={sortValue} sortName="managedCompanies" />
            </th>
            <th colSpan="1">Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies && companies.length ? (
            companies.map(company => (
              <CompanyGroups
                onRecover={onRecover}
                deleteMode={deleteMode}
                key={company._id}
                company={company}
                onDelete={onDelete}
                onSetStatus={onSetStatus}
                onEdit={onEdit}
                // disabled={company._id === disabledCompany}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5}>
                <Alert rowSpan={5} color="info">
                  No Company Groups Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CompanyGroupList;
